<template>
    <v-container fluid grid-list-xl>
        <v-layout wrap>
            <!--<v-flex xs12>-->
                <!--<h2 class="heading">Description</h2>-->
                <!--<p class="signup-subheading">about the disease</p>-->
            <!--</v-flex>-->

            <v-flex xs12>
                <div style="padding-bottom: 16px">
                    <h1 class="headline" style="color: #114c74">{{symptom.loadedDisease.Name}}</h1>
                    <h2 class="subheading" style="font-style: italic" v-if="symptom.loadedDisease.ProfName != null && symptom.loadedDisease.ProfName != ''">
                        {{ symptom.loadedDisease.ProfName}}</h2>
                </div>

                <h3 class="display-5" v-if="symptom.loadedDisease.DescriptionShort != null && symptom.loadedDisease.DescriptionShort != ''">
                    Summary</h3>
                <p>
                    {{ symptom.loadedDisease.DescriptionShort}}
                </p>
                <h3 class="display-5" v-if="symptom.loadedDisease.Description != null && symptom.loadedDisease.Description != ''">
                    Description</h3>
                <p>
                    {{ symptom.loadedDisease.Description}}
                </p>
                <h3 class="display-5" v-if="symptom.loadedDisease.MedicalCondition != null && symptom.loadedDisease.MedicalCondition != ''">
                    Occurrence + Symptoms</h3>
                <p>
                    {{ symptom.loadedDisease.MedicalCondition}}
                </p>
                <h3 class="display-5" v-if="symptom.loadedDisease.TreatmentDescription != null && symptom.loadedDisease.TreatmentDescription != ''">
                    Consequences + Treatment</h3>
                <p>
                    {{ symptom.loadedDisease.TreatmentDescription}}
                </p>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import priaid from '@/lib/priaid/Client'
    import {mapState, mapGetters} from 'vuex'

    export default {
        data() {
            return {
                tmp: null
            }
        },
        computed: {
            ...mapState(['symptom'])
        },
        methods: {},
        mounted() {
            Loading.hide()
        }
    }
</script>